import React, { useEffect } from 'react';
import Confetti from 'react-confetti';
import './FinPartie.scss';

const FinPartie = ({ gagnant, players = [], onRejouer, isHost = true }) => {

    // Déclenchement du son de victoire finale à l'ouverture
    useEffect(() => {
        const audio = new Audio('/Sound/applaudissementVictoire.mp3');
        audio.volume = 0.7; // Volume festif
        audio.play().catch(error => {
            console.log("Lecture du son bloquée par le navigateur :", error);
        });
    }, []);

    // Sécurité au cas où la modale s'affiche avant que le gagnant soit calculé
    if (!gagnant) return null;

    // Filtrer et trier les autres joueurs par score décroissant
    const autresJoueurs = players
        .filter(p => p && String(p.id) !== String(gagnant.id))
        .sort((a, b) => (b.score || 0) - (a.score || 0));

    return (
        <div className="modal-overlay">
            {/* Confettis en boucle pour célébrer la fin de partie */}
            <Confetti
                width={window.innerWidth}
                height={window.innerHeight}
                recycle={true}
                numberOfPieces={350}
                gravity={0.12}
            />

            <div className="modal-content victory-modal">
                {/* En-tête Gagnant */}
                <div className="victory-header">
                    <div className="winner-trophy-badge">🏆</div>
                    <h2>
                        Bravo <span className="winner-name">{gagnant.name}</span>, vous avez gagné !
                    </h2>
                    <div className="winner-score-badge">
                        <span>{gagnant.score || 0}</span> points
                    </div>
                </div>

                {/* Classement des autres joueurs dans l'ordre décroissant */}
                {autresJoueurs.length > 0 && (
                    <div className="other-players-section">
                        <h3 className="other-players-title">Score des autres joueurs</h3>
                        <div className="other-players-list">
                            {autresJoueurs.map((player, idx) => (
                                <div 
                                    key={player.id || idx} 
                                    className="other-player-card"
                                    style={{ borderLeftColor: player.color || '#94a3b8' }}
                                >
                                    <div className="player-rank">
                                        {idx === 0 ? '🥈 2e' : idx === 1 ? '🥉 3e' : `4e`}
                                    </div>
                                    <div className="player-info-group">
                                        <div 
                                            className="player-avatar" 
                                            style={{ backgroundColor: player.color || '#3b82f6' }}
                                        >
                                            {player.name ? player.name.charAt(0).toUpperCase() : 'J'}
                                        </div>
                                        <span className="player-name">{player.name}</span>
                                    </div>
                                    <div className="player-points">
                                        <strong>{player.score || 0}</strong> pts
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                )}

                {/* Bouton pour relancer la partie (Joueur A / Créateur) */}
                <div className="victory-actions">
                    {isHost ? (
                        <button className="btn-rejouer" onClick={onRejouer}>
                            <span className="btn-main">REJOUER 🚀</span>
                            <span className="btn-sub">(Même joueur)</span>
                        </button>
                    ) : (
                        <div className="host-waiting-container">
                            <button className="btn-rejouer disabled" disabled>
                                <span className="btn-main">EN ATTENTE DU JOUEUR A... ⏳</span>
                            </button>
                            <p className="host-waiting-hint">
                                Seul le Joueur A (créateur de la partie) peut remettre à zéro les compteurs et relancer la partie.
                            </p>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default FinPartie;